exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "label {\r\n\tfont-size: 10pt;\r\n\tfont-weight: normal;\r\n\tcolor: #444;\r\n} \r\n\r\n.ui-autocomplete-multiple-container {\r\n\twidth: 100%;\r\n}\r\n\r\n.buttonOn {\r\n    background-color: #e6e6e6;\r\n    border-color: #adadad;\r\n    box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/presences/presences.component.css
// module id = 348
// module chunks = 0